/* 组件需要提供parent字段，指定表格的className（字符串）; 适用于ag-grid的table组件 */
const rafThrottle = (fn) => {
    let locked = false;
    return function (...args) {
        if (locked) return;
        locked = true;
        window.requestAnimationFrame((_) => {
            fn.apply(this, args);
            locked = false;
        });
    };
};
export default {
    data() {
        return {
            tablexy: {}, // 表格的左边宽度信息
            scrollDom: null, // 滚动的dom
            parentDom: null, // 表格的父元素dom
            tableWidth: 0,
            fixedTop: 81, // 顶部fixed高度
            fixedbodyWrapperTop: '30px', // table row height
            timerList: [],
            tableDom: null,
            containerDom: null,
        };
    },
    mounted() {
        if (!this.isNeedSticky) return;
        this.containerDom = document.getElementsByClassName('layout-main');
        this.clearListener();
        const timer = setTimeout(() => {
            this.initFixedHeader();
            clearTimeout(timer);
        }, 300);
        window.addEventListener('resize', this.resizeChange);
    },
    deactivated() {
        if (!this.isNeedSticky) return;
        this.clearListener();
    },
    beforeDestroy() {
        if (!this.isNeedSticky) return;
        this.clearListener();
        // 取消监听窗口大小
        window.removeEventListener('resize', this.resizeChange);
    },
    activated() {
        if (!this.isNeedSticky) return;
        this.initFixedHeader();
        window.addEventListener('resize', this.resizeChange);
        const timer = setTimeout(() => {
            const container = this.containerDom;
            if (container[0].scrollTop > 0) {
                container[0].scrollTop += 2;
            }
            clearTimeout(timer);
        }, 1000);
    },
    methods: {
        // 窗口大小变化时，初始化
        resizeChange() {
            this.headerDragend();
            const timer = setTimeout(() => {
                this.initFixedHeader();
                clearTimeout(timer);
            }, 300);
        },
        async initFixedHeader() {
            if (this.parent) {
                // console.log('启动监听，页面：', this.parent)
                this.parentDom = document.getElementsByClassName(this.parent);
                if (this.parentDom && this.parentDom.length !== 0) {
                    this.tableWidth = this.parentDom[0]
                        .querySelector('.ag-header')
                        .getBoundingClientRect().width;
                    this.setScrollXWidth();
                    this.tableDom = this.parentDom[0].getElementsByClassName('ag-header');
                    this.scrollDom = document.querySelector('.layout-main'); // 外层滚动dom
                    this.scrollDom.addEventListener('scroll', this.scrollEvent);
                    this.scrollEvent(); // 修复切换页面后吸顶未重置bug
                }
            }
        },
        // 清空监听事件
        clearListener() {
            console.log('清空监听事件', this.scrollDom);
            if (this.scrollDom) {
                this.scrollDom.removeEventListener('scroll', this.scrollEvent);
                window.removeEventListener('resize', this.resizeChange);
                this.clearFixedStyle();
                // console.log('卸载监听,页面：', this.parent)
                this.timerList.forEach((key) => {
                    clearTimeout(key);
                });
            }
        },
        async headerDragend() {
            await this.updateWidth();
            this.setScrollXWidth();
        },
        setScrollXWidth() {
            const timer = setTimeout(() => {
                if (!this.parentDom) this.parentDom = document.getElementsByClassName(this.parent);
                if (this.parentDom.length === 0) return;
                const dom = this.parentDom[0].querySelector('.ag-header');
                this.tableWidth = this.parentDom[0]
                    .querySelector('.ag-body')
                    .getBoundingClientRect().width;
                this.tableDom[0].style.width = `${this.tableWidth}px`;
                this.headerWidth = dom.style.width;
                clearTimeout(timer);
            }, 200);
        },
        // 更新表格宽度，（拖拽改变宽度时使用）
        updateWidth() {
            if (!this.parentDom) this.parentDom = document.getElementsByClassName(this.parent);
            const bodyWrapperDom = this.parentDom[0].getElementsByClassName('ag-body')[0];
            const { width } = getComputedStyle(bodyWrapperDom); // 表格宽度
            // 给表格设置宽度。
            const tableParent = this.tableDom;
            for (let i = 0; i < tableParent.length; i++) {
                tableParent[i].style.width = width;
            }
        },
        getFixedDom() {
            const dom = this.tableDom[0];
            return {
                dom,
            };
        },
        // 获取表格属性
        getTableXy() {
            this.tablexy = this.tableDom[0].getBoundingClientRect();
            this.tablexy.height = this.tableDom[0].offsetHeight;
            return this.tablexy;
        },
        getDom() {
            if (!this.parentDom) {
                this.parentDom = document.getElementsByClassName(this.parent);
            }
        },
        // 滚动事件
        scrollEvent: rafThrottle(async function (e) {
            this.getDom();
            this.tableDom = this.parentDom[0].getElementsByClassName('ag-header');
            if (this.tablexy.top === 0 || !this.tablexy.height || !this.tablexy.top) {
                await this.getTableXy();
            }
            const {
                dom,
            } = this.getFixedDom();
            // 获取表格到顶部的距离
            const parentTop = this.parentDom[0].getBoundingClientRect().top; // 修复吸顶
            if (parentTop - this.fixedTop <= 0) {
                this.fixedbodyWrapper(this.fixedbodyWrapperTop);
                dom.classList.add('fixed'); // 加一个固定标识
                this.updateWidth();
                dom.style.position = 'fixed';
                dom.style.zIndex = '900';
                dom.style.top = `${this.fixedTop}px`;
                dom.style.overflow = 'hidden';
            } else {
                this.fixedbodyWrapper('0px');
                this.clearFixedStyle();
            }
        }),
        // 清除header固定
        clearFixedStyle() {
            if (!this.tableDom) return;
            const {
                dom,
            } = this.getFixedDom();
            if (dom.classList.contains('fixed')) {
                dom.classList.remove('fixed');
                dom.style.position = 'static';
                dom.style.top = '0';
                dom.style.zIndex = '0';
            }
        },
        // 解决table表格 特定高度 抖动问题
        fixedbodyWrapper(topPx) {
            const bodyWrapper = this.parentDom[0].getElementsByClassName('ag-body')[0];
            if (bodyWrapper) {
                bodyWrapper.style.marginTop = topPx;
            }
        },
    },
};
